import { render } from "./AboutBranchSection.vue?vue&type=template&id=619cd6dd"
import script from "./AboutBranchSection.vue?vue&type=script&lang=js"
export * from "./AboutBranchSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__